import { TrendingUp, SlidersHorizontal, Check } from 'lucide-react';
import React from 'react';
import LeafIcon from '../../../assets/leaf-icon.svg';
import SeedIcon from '../../../assets/seed-icon.svg';
import MechanicsIllustration from '../../../assets/welcoming-slide-6-mechanics.png';

interface Step {
  icon: React.ReactNode;
  title: string;
  items: string[];
}

const steps: Step[] = [
  {
    icon: <img src={LeafIcon} alt="Twig" className="w-6 h-6 md:w-7 md:h-7" />,
    title: 'Give Twigs',
    items: [
      'See something valuable? Give it 1-5 Twigs',
      'Your Twigs become Seeds for the creator',
      'You have 20 daily - use them wisely!'
    ]
  },
  {
    icon: <img src={SeedIcon} alt="Seed" className="w-8 h-8 md:w-9 md:h-9" />,
    title: 'Earn Seeds',
    items: [
      'Create quality content or thoughtful comments',
      'Receive Twigs from readers',
      'Twigs received convert to Seeds (your investment capital)'
    ]
  },
  {
    icon: <TrendingUp className="w-7 h-7 md:w-8 md:h-8 text-green-600" />,
    title: 'Invest & Earn',
    items: [
      'Find promising content early',
      'Invest your Seeds',
      'Share in the success (earn a portion of the ad revenue)'
    ]
  },
  {
    icon: <SlidersHorizontal className="w-6 h-6 md:w-7 md:h-7 text-green-600" />,
    title: 'Customize Your Feed',
    items: ['Tap the filter icon', 'Adjust content preferences', 'See what YOU want to see']
  }
];

function Card({ step }: { step: Step }) {
  return (
    <div className="relative bg-gradient-to-r from-[#F9F6FE] to-[#F4FDF6] rounded-xl p-3 shadow-sm border border-[#ECE8F5]">
      <div className="flex items-start">
        <div className="rounded-md w-8 h-8 flex items-center justify-center mr-2">{step.icon}</div>
        <div className="flex-1">
          <h3 className="font-extrabold text-gray-900 mb-3 text-base">{step.title}</h3>
          <ul className="md:mx-0">
            {step.items.map((item, i) => (
              <li key={i} className="flex items-start">
                <Check className="w-4 h-4 text-green-600 mt-1 mr-2 flex-shrink-0" />
                <span className="text-gray-700 leading-relaxed text-sm">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default function Slide6() {
  return (
    <div className="animate-in slide-in-from-right duration-300 relative">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left md:text-center w-[80%] md:w-full">
        The mechanics of the platform
      </h1>

      {/* Illustration on large screens */}
      <img
        src={MechanicsIllustration}
        alt="Mechanics Illustration"
        className="absolute top-8 z-10 -right-3 md:-right-8 w-32 md:w-80 pointer-events-none select-none"
      />

      <div className="space-y-5 mx-0 md:mx-6">
        {/* First two stacked */}
        <div className="space-y-5">
          <Card step={steps[0]} />
          <Card step={steps[1]} />
        </div>

        {/* Bottom two in grid */}
        <div className="grid md:grid-cols-2 gap-5">
          <Card step={steps[2]} />
          <Card step={steps[3]} />
        </div>
      </div>
    </div>
  );
}
